import {findMaxE}  from "@Common/utils/collections";
import {chain}     from "@Common/utils/fs";
import {equalDeep} from "@Common/utils/objects";

import {sizeToVector} from "../main-panel/size-to-vector";
import {vectorToSize} from "../main-panel/vector-to-size";

import {addVector}       from "./add-vector";
import {getContainRatio} from "./get-contain-ratio";
import {inSize}          from "./in-size";
import {multiplyVector}  from "./multiply-vector";
import {normalizeVector} from "./normalize-vector";
import {roundVector}     from "./round-vector";
import {subtractVector}  from "./subtract-vector";

export const applyAspectRatio = ({p2, p1, aspectRatio, size}) => {
    // console.log("aspectRatio", aspectRatio);
    // console.log({p2, p1, aspectRatio, size})
    const delta1 = subtractVector(p2, p1);

    const farthestPoint2 = chain(
        sizeToVector(aspectRatio),

        (_) => findMaxE(
            [
                multiplyVector(_, Math.abs(delta1.x) / _.x),
                multiplyVector(_, Math.abs(delta1.y) / _.y),
            ],
            (_) => _.x * _.y,
        ),

        (_) => multiplyVector2(_, normalizeVector(delta1)),
        roundVector,
        (_) => addVector(p1, _),
        // (_) => pointsToRect(p1, _),
    );

    const inSize2 = inSize(farthestPoint2, size);
    if (equalDeep(inSize2, farthestPoint2)) {
        return farthestPoint2;
    }

    const ratio = getContainRatio(
        vectorToSize(absVector(subtractVector(inSize2, p1))),
        aspectRatio,
    );
    return chain(
        multiplyVector(
            sizeToVector(aspectRatio),
            ratio,
        ),
        (_) => multiplyVector2(_, normalizeVector(subtractVector(inSize2, p1))),
        (_) => addVector(p1, _),
        roundVector,
    );
};

const absVector = (p) => ({
    x: Math.abs(p.x),
    y: Math.abs(p.y),
});


const multiplyVector2 = (p1, p2) => ({
    x: p1.x * p2.x,
    y: p1.y * p2.y,
});

